import wretch from "wretch";
import * as Sentry from "@sentry/nextjs";
import {
  IRegisterStudentPayload,
  IRegisterStudentAPIResponse
} from "./profileService.types";
import { didUserRegisterViaBlocker, generateUUID } from "utils/utils";

const BASE_URL = `${process.env.NEXT_PUBLIC_BASE_API}`;

export const registerStudent = ({
  payload,
  token,
  platform
}: {
  payload: IRegisterStudentPayload;
  token: string;
  platform: string;
}): Promise<IRegisterStudentAPIResponse> => {
  try {
    const isUserOfGrade12 = payload.grade === "12" ? true : false;

    const userRegisterViaVideoBlockerExperiment = didUserRegisterViaBlocker();
    const payloadWithExperimentData = {
      ...payload,
      ...(!isUserOfGrade12 && userRegisterViaVideoBlockerExperiment
        ? {
            experiment: userRegisterViaVideoBlockerExperiment
          }
        : {})
    };
    return wretch(`${BASE_URL}/user-management/v1/users/register`)
      .headers({
        Authorization: `Bearer ${token}`,
        "x-iq-request-id": generateUUID(),
        "x-iq-platform": platform
      })
      .post(payloadWithExperimentData)
      .json();
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};
